import React from 'react';
import { ChecklistMetricStatus } from '../handoff-checklist-v2.types';
import { ReactComponent as StatusErrorIcon } from 'images/status-error.svg';
import { ReactComponent as StatusWarningIcon } from 'images/status-warning.svg';
import { ReactComponent as StatusSuccessIcon } from 'images/status-success.svg';

export const getStatusIcon = (
  status: ChecklistMetricStatus
): React.ComponentType<React.SVGProps<SVGSVGElement>> | null => {
  switch (status) {
    case ChecklistMetricStatus.BLOCKED:
      return StatusErrorIcon;
    case ChecklistMetricStatus.WARNING:
    case ChecklistMetricStatus.EXCEPTION_NOTED:
      return StatusWarningIcon;
    case ChecklistMetricStatus.PASSED:
      return StatusSuccessIcon;
    default:
      return null;
  }
};
